import { useQuery, gql } from "@apollo/client";

import { loggedOutPricingPagePlansQuery } from "@/graphql-types";

const planFragment = gql`
  fragment pricingPage_planFragment on PlanV2 {
    allowCompanies
    amount
    description
    features {
      href
      name
      tooltip
    }
    hasAutoReplay
    hasMeteredBilling
    hasMultiStepZaps
    hasPaths
    hasPremiumApps
    hasTeams
    id
    interval
    isInPlanGroup
    memberLimit
    name
    tasks
    tiers {
      numTasks
      pricePerTask
    }
    type
    zaps
    zapsRunInterval
  }
`;

export const plansQuery = gql`
  query loggedOutPricingPagePlansQuery($accountId: Int) {
    planStacks: pricingPageV3Plans(accountId: $accountId) {
      id
      planType
      plans {
        ...pricingPage_planFragment
      }
    }
  }
  ${planFragment}
`;

type Options = {
  skip?: boolean;
};

export const usePlans = ({ skip }: Options = {}) => {
  const {
    data: plansData,
    error: plansError,
    loading: isLoadingPlans,
  } = useQuery<loggedOutPricingPagePlansQuery>(plansQuery, {
    skip,
    variables: {
      accountId: null,
    },
  });

  return {
    error: plansError
      ? "There was an issue loading data. Please try again."
      : null,
    isLoading: isLoadingPlans,
    planStacks: plansData?.planStacks ?? [],
  };
};
